<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/uFbSt3/tc-custom/9781453237526.jpg?1733084926337" alt="This image is the cover for the book Outlaw in Paradise"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Outlaw in Paradise
      </h1>
      <p class="bookDescription body article font2">
        <b>A legendary gunfighter brings big trouble to a frontier town, and ignites the passion of a local saloon owner </b> When Jesse Gault saunters into Paradise, Oregon, with a gun on each hip, the town is instantly abuzz. What could a legendary gunslinger want in Paradise? And what will the townsfolk have to do to keep his trouble from becoming their own? Cady McGill, proprietor of the Rogue Tavern, thinks she may know what Gault has come for, and she doesn’t like it one bit. Cady’s ongoing battle with Merle Wylie, who has been buying up or burning down properties all over town, is coming to a head, as Wylie tries to get his hands on her tavern and her dried-up gold mine. Hiring a gunfighter like Gault would be just Wylie’s speed. But Cady senses something else behind Gault’s mysterious façade, and as the two grow closer she learns that his closely guarded secrets could spell life or death for the town—and for Cady herself.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Patricia Gaffney
      </h2>
      
      <p class="authorDescription body article">&amp;lt;p&amp;gt;Patricia Gaffney's novels include &amp;lt;em&amp;gt;The Goodbye Summer&amp;lt;/em&amp;gt;, &amp;lt;em&amp;gt;Flight Lessons&amp;lt;/em&amp;gt;, and &amp;lt;em&amp;gt;The Saving Graces&amp;lt;/em&amp;gt;. She and her husband currently live in Blue Ridge Summit, Pennsylvania.&amp;lt;/p&amp;gt;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8f3c0c6c